import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useLinksSection} from '../useGetProductBulkSection';
import {DiscoverMoreView} from './DiscoverMoreView';

export const DiscoverMore: React.FC = props => {
  return (
    <DataFetcher
      request={useLinksSection()}
      Error={null}
      viewProps={props}
      View={DiscoverMoreView}
    />
  );
};
